import React from "react";
import { Box, Text, Inline, MenuRenderer, MenuItem, IconProfile, Hidden, IconDisallow } from "braid-design-system";
import { useAuth } from "../contexts/AuthProvider";

const LogoutButton: React.FC = () => {
    const [loading, setLoading] = React.useState(false);
    const { logout, user } = useAuth();

    const handleLogout = async () => {
        try {
            setLoading(true);
            await logout();
        } catch (error: any) {
            alert(error.message || "Logout failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Inline space="none">
            <MenuRenderer
                offsetSpace="small"
                width="medium"
                trigger={(triggerProps) => (
                    <Box userSelect="none" cursor="pointer" {...triggerProps}>
                        <Hidden below="tablet">
                            <Text icon={<IconProfile />} size="small" tone="brandAccent" weight="strong">
                                @{!loading ? user?.user_name : "..."}
                            </Text>
                        </Hidden>
                        <Hidden above="tablet">
                            <IconProfile />
                        </Hidden>
                    </Box>
                )}
            >
                <MenuItem onClick={handleLogout} tone="critical" icon={<IconDisallow />}>Logout</MenuItem>
            </MenuRenderer>
        </Inline>
    );
};

export default LogoutButton;
